import { upperFirst, camelCase } from 'lodash';

var styles = {"alignLeft":"pWgvE","textWrapNowrap":"g1nrr","alignRight":"Qetl-","alignCenter":"_7ST4i","sizeFullWidth":"KGqwb","renderedInTable":"wllZd","sizeOriginal":"Uy28N","sizeContent":"Bd1Hb","sizeSmall":"Tm-Ky","sizeSmallCenter":"O0ut7","flex":"p38dg","atomic":"_7TqVM","anchor":"TRCl0","embed":"o4HNW","horizontalScrollbar":"h2yJA","pluginContainerMobile":"uocwM"};

const getContainerData = (node) => {
  var _a;
  const data = `${camelCase(node.type)}Data`;
  return (_a = node == null ? void 0 : node[data]) == null ? void 0 : _a.containerData;
};
const getAlignmentClassName = (containerData = {}) => {
  const { alignment } = containerData;
  if (!alignment) {
    return "";
  }
  const key = `align${upperFirst(alignment.toLowerCase())}`;
  return styles[key];
};
const getSizeClassName = (containerData) => {
  const { width } = containerData;
  const { size } = width || {};
  if (!size) {
    return "";
  }
  const key = `size${upperFirst(camelCase(size.toLowerCase()))}`;
  return styles[key];
};
const getTextWrapClassName = (containerData = {}) => {
  const { textWrap } = containerData;
  if (textWrap) {
    return "";
  }
  return styles.textWrapNowrap;
};
const alignmentClassName = (node) => {
  return getAlignmentClassName(getContainerData(node));
};
const sizeClassName = (node) => {
  return getSizeClassName(getContainerData(node) || {});
};
const textWrapClassName = (node) => {
  return getTextWrapClassName(getContainerData(node));
};

export { getSizeClassName as a, getTextWrapClassName as b, alignmentClassName as c, sizeClassName as d, getAlignmentClassName as g, styles as s, textWrapClassName as t };
//# sourceMappingURL=getClassNames-62f7881c.js.map
